<script>
import $util from '@/common/js/util';

/* eslint-disable no-undef */
const codeEvn = CODE_EVN;
/* eslint-enable no-undef */
const isDev = codeEvn === 'development';
const domain = isDev ? 'http://dev.aiclk.com/#' : 'http://staging.aiclk.com/#';

export default {
    name: 'Transform',
    render: h => h('div'),
    methods: {
        toPage (sign = '') {
            $util.openUrl(`${domain}${sign}`, { newWin: true });
        }
    },
    beforeRouteEnter (to, from, next) {
        const { meta } = to;
        next(vm => {
            vm.toPage(meta.redirect);
        });
    }
};
</script>
